import { type PrimaryPageAction, EmptyStateOnboarding, ExternalLink } from "@octopusdeploy/design-system-components";
import { FeatureTogglesEmptyStateIllustration } from "./FeatureTogglesEmptyStateIllustration";
type FeatureTogglesOnboardingProps = {
    primaryAction: PrimaryPageAction;
};
export function FeatureTogglesOnboarding({ primaryAction }: FeatureTogglesOnboardingProps) {
    return (<EmptyStateOnboarding description={<div>
                    <div>Control feature rollouts without redeploying.</div>
                    <div>Use feature toggles to test in production, gather feedback early, and reduce release risk — helping your team ship faster with confidence.</div>
                </div>} primaryAction={primaryAction} title="Release safely and continuously with Feature Toggles" image={<FeatureTogglesEmptyStateIllustration />} learnMore={<ExternalLink href={"featuretoggles"}>Learn more</ExternalLink>}/>);
}
